export default __webpack_public_path__ + "static/media/mentex-logo.3480e6f5.png";